export const headerKeyMapping = {
  hitDetail: '',
  comparison: 'COMPARISON',
  nameMatchingScore: 'NAME MATCHING SCORE',
  profileMatchingFeatures: 'PROFILE MATCHING FEATURES'
};

export const weightageHeaders = [
  'nameNameMatch',
  'nameAliasMatch',
  'addressMatch',
  'dateOfBirthMatch',
  'countryofBirthMatch',
  'nationalityMatch'
];

export const getHitLevelByScore = (score) => {
  if (score > 80) {
    return 'High';
  } else if (score < 80 && score > 70) {
    return 'Good';
  } else {
    return 'Low';
  }
};

export const getAlertColorCode = (level) => {
  let color = '';
  if (level) {
    if (level.toLowerCase() === 'high') color = '#DF6057';
    // red
    else if (level.toLowerCase() === 'good') color = '#E29840';
    // orange
    else color = '#71C969'; // green
  }
  return color;
};
